<li ngbDropdown class="nav-item dropdown-notification mr-25">
  <a class="nav-link" ngbDropdownToggle id="navbarNotificationDropdown">
    <i
      ngbTooltip="Detalle zona horaria"
      class="action font-medium-5 fa-regular fa-clock"
      (click)="refreshDetails()"
    ></i>
  </a>
  <ul
    ngbDropdownMenu
    aria-labelledby="navbarNotificationDropdown"
    class="dropdown-menu dropdown-menu-media dropdown-menu-right"
    style="width: 18rem !important"
  >
    <li class="dropdown-menu-header">
      <div class="timezone-container">
        <!-- Zona Horaria del Cliente -->
        <div class="timezone-item" *ngIf="isSender">
          <div class="timezone-icon client-icon">
            <i class="fas fa-user-clock"></i>
          </div>
          <div class="timezone-info">
            <span class="timezone-title">Cliente:</span>
            <div class="timezone-details">
              {{ company.tz }} |
              <span class="timezone-offset">({{ company.offset }})</span>
            </div>
          </div>
        </div>

        <!-- Zona Horaria del Navegador -->
        <div class="timezone-item">
          <div class="timezone-icon browser-icon">
            <i class="fas fa-globe-americas"></i>
          </div>
          <div class="timezone-info">
            <span class="timezone-title">Navegador:</span>
            <div class="timezone-details">
              {{ browser.tz }} |
              <span class="timezone-offset">({{ browser.offset }})</span>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</li>
